import { IAuthorizationGranted } from '../../../actions/userAccount/authorize/authorize'
import { IUserAccountStore } from '../index'

export default function(
  state: IUserAccountStore,
  action: IAuthorizationGranted,
): IUserAccountStore {
  return {
    ...state,
    credentials: {
      accessToken: action.accessToken,
    },
    isAuthorizing: false,
  }
}
